module.exports = __webpack_public_path__ + "img/newGoldenNugget.5463f354.jpg";